/**
 * Permission keys the backend hands out (GET /api/admin/permissions).
 * A user holds Make OR Approve, never both: whoever creates a payment can't pay it.
 */
export const PAYMENT_PERMISSIONS = {
  /** Maker: sees balances, creates payment requests, withdraws their own pending ones. */
  make: 'Payments.Make',
  /** Approver (finance officer): pays requests with an OTP, or rejects them. */
  approve: 'Payments.Approve',
} as const;

export type PaymentPermission = (typeof PAYMENT_PERMISSIONS)[keyof typeof PAYMENT_PERMISSIONS];

/** One entry in the permission catalogue. */
export interface PermissionCatalogItem {
  key: string;
  name: string;
  description: string;
  group: string;
  conflictsWith: string[];
}

/** Response of GET /api/admin/permissions for the signed-in user. */
export interface MyPermissions {
  /** Keys this user holds, e.g. ["Payments.Approve"]. */
  permissions: string[];
  /** True only for the organisation's first admin (can assign keys). */
  canManagePermissions: boolean;
  catalog: PermissionCatalogItem[];
}
